import { AccountPage } from '@gig/magic-account-types';
import { Jurisdiction } from '@gig/magic-jurisdictions';
import { USER_JURISDICTION_UPDATED } from '@gig/magic-messages';

export const AccountPageNames = {
    CLOSURE: AccountPage.CLOSURE,
    MARKETING_PREFS: AccountPage.MARKETING_PREFS,
    PROFILE: AccountPage.PROFILE,
    RESPONSIBLE_GAMING: AccountPage.RESPONSIBLE_GAMING,
    SOURCE_OF_WEALTH: AccountPage.SOURCE_OF_WEALTH,
    VERIFICATION: AccountPage.VERIFICATION,
    LINK_ACCOUNT: AccountPage.CUSTOM_ITEM,
};

export const SIGN_UP_FORM_STEPS_QUERY = 'SIGN_UP_FORM_STEPS';

export const getAccountComponent =
    (component: keyof typeof import('./account.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "account" */
            './account.chunk'
        );
        return chunk[component];
    };

export const getRGPComponent =
    (component: keyof typeof import('./responsible-gaming.chunk')) =>
    async () => {
        const chunk = await import(
            /* webpackChunkName: "responsible-gaming" */
            './responsible-gaming.chunk'
        );
        return chunk[component];
    };

export const getONJNComponent =
    (component: keyof typeof import('./onjn.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "onjn" */
            './onjn.chunk'
        );
        return chunk[component];
    };

export const getAGCOComponent =
    (component: keyof typeof import('./agco.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "agco" */
            './agco.chunk'
        );
        return chunk[component];
    };

export const getAGLCComponent =
    (component: keyof typeof import('./aglc.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "aglc" */
            './aglc.chunk'
        );
        return chunk[component];
    };

const SCAN_VERIFICATION_BY_JURISDICTION = {
    [Jurisdiction.AGCO]: {
        component: getAGCOComponent('AgcoScanVerificationModalComponent'),
        title: 'agco-scan-verify-flow-modal.title',
    },
    [Jurisdiction.AGLC]: {
        component: getAGLCComponent('AglcScanVerificationModalComponent'),
        title: 'aglc-scan-verify-flow-modal.title',
    },
};

function currentScanVerification() {
    const jurisdiction = window.eventBus?.getLatest<Jurisdiction>(
        USER_JURISDICTION_UPDATED,
    );
    const config =
        SCAN_VERIFICATION_BY_JURISDICTION[
            jurisdiction as keyof typeof SCAN_VERIFICATION_BY_JURISDICTION
        ];
    if (!config) {
        throw new Error(
            `Identity verification route requires a Canadian jurisdiction (got: ${jurisdiction ?? 'undefined'})`,
        );
    }
    return config;
}

export const getScanVerificationComponent = () => () =>
    currentScanVerification().component();

export const getScanVerificationTitle = () => currentScanVerification().title;
